import { Link, useLocation } from "react-router-dom";

import { MyTasksModal } from "components/Header/components/MyTasksModal/MyTasksModal";
import { Button } from "components/ui/Button";
import { pathGenerators } from "utils/routes";

import styles from "./HeaderNavLinks.module.css";

export function HeaderNavLinks({
  goToPatientDetails,
  goToPatientConsult,
}) {
  const location = useLocation();
  const isAppointmentsPage = location.pathname === pathGenerators.global.appointments();

  return (
    <div className={styles.navLinks}>
      <Button
        as={Link}
        to={pathGenerators.global.appointments()}
        state={isAppointmentsPage ? { action: "add" } : undefined}
        variant="primary"
        size="large"
      >
        {isAppointmentsPage ? "Book an appointment" : "Appointments"}
      </Button>
      <MyTasksModal
        goToPatientDetails={goToPatientDetails}
        goToPatientConsult={goToPatientConsult}
      />
    </div>
  );
}
